import React, { useState } from 'react';
import { Save, AlertTriangle, Package } from 'lucide-react';
import { 
  stocks as stocksData,
  produits,
  centres,
  getProduitById,
  getCentreById,
  getCategorieById,
  getStocksByCentre,
  isStockEnAlerte 
} from '../../data/mockData';

function GestionStock({ user }) {
  const [selectedCentre, setSelectedCentre] = useState(
    user.role === 'technicien' ? user.centreId : ''
  );
  const [stocks, setStocks] = useState(stocksData);
  const [message, setMessage] = useState({ type: '', text: '' });

  const centreActuel = selectedCentre ? getCentreById(parseInt(selectedCentre)) : null;
  const stocksCentre = selectedCentre ? getStocksByCentre(parseInt(selectedCentre)) : [];

  const handleCentreChange = (e) => {
    setSelectedCentre(e.target.value);
    setMessage({ type: '', text: '' });
  };

  const handleQuantiteChange = (stockId, newQuantite) => {
    setStocks(stocks.map(s =>
      s.id === stockId ? { ...s, quantite: parseInt(newQuantite) } : s
    ));
  };

  const handleSave = () => {
    console.log('Stocks sauvegardés:', stocks);
    setMessage({ type: 'success', text: 'Les stocks ont été mis à jour avec succès !' });
    
    // Vérifier les alertes
    const alertes = stocksCentre.filter(s => {
      const produit = getProduitById(s.produitId);
      return produit && s.quantite <= produit.seuilAlerte;
    });

    if (alertes.length > 0) {
      console.log('Alertes stock:', alertes);
      setMessage({ 
        type: 'warning', 
        text: `${alertes.length} produit(s) en alerte. Un email a été envoyé à l'administrateur.` 
      });
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Gestion des stocks</h1>
          <p className="text-muted">Mise à jour des quantités en stock</p>
        </div>
      </div>

      {message.text && (
        <div className={`alert alert-${message.type}`}>
          {message.text}
        </div>
      )}

      <div className="filters-bar">
        <div className="form-group">
          <label htmlFor="centre">Centre</label>
          <select
            id="centre"
            value={selectedCentre}
            onChange={handleCentreChange}
            disabled={user.role === 'technicien'}
            className="filter-select"
          >
            <option value="">Sélectionnez un centre</option>
            {centres.map(centre => (
              <option key={centre.id} value={centre.id}>
                {centre.nom}
              </option>
            ))}
          </select>
        </div>
      </div>

      {!selectedCentre ? (
        <div className="empty-state">
          <Package size={48} className="icon-muted" />
          <p>Sélectionnez un centre pour gérer son stock</p>
        </div>
      ) : (
        <>
          <div className="stocks-header">
            <h2>{centreActuel?.nom}</h2>
            <button onClick={handleSave} className="btn btn-primary">
              <Save size={20} />
              Enregistrer les modifications
            </button>
          </div>

          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Produit</th>
                  <th>Catégorie</th>
                  <th>Quantité actuelle</th>
                  <th>Seuil d'alerte</th>
                  <th>Statut</th>
                </tr>
              </thead>
              <tbody>
                {stocksCentre.map(stock => {
                  const produit = getProduitById(stock.produitId);
                  const categorie = getCategorieById(produit?.categorieId);
                  const enAlerte = isStockEnAlerte(parseInt(selectedCentre), stock.produitId);
                  
                  return (
                    <tr key={stock.id} className={enAlerte ? 'row-alert' : ''}>
                      <td>
                        <div className="flex items-center gap-2">
                          <Package size={16} className="icon-muted" />
                          <strong>{produit?.nom}</strong>
                        </div>
                      </td>
                      <td>
                        <span className="badge badge-secondary">
                          {categorie?.nom}
                        </span>
                      </td>
                      <td>
                        <div className="stock-input-group">
                          <input
                            type="number"
                            value={stock.quantite}
                            onChange={(e) => handleQuantiteChange(stock.id, e.target.value)}
                            min="0"
                            className="stock-input"
                          />
                          <span className="stock-unit">{produit?.unite}</span>
                        </div>
                      </td>
                      <td>
                        <span className="text-muted">
                          {produit?.seuilAlerte} {produit?.unite}
                        </span>
                      </td>
                      <td>
                        {enAlerte ? (
                          <span className="badge badge-danger">
                            <AlertTriangle size={14} />
                            Alerte
                          </span>
                        ) : (
                          <span className="badge badge-success">OK</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}

export default GestionStock;

